export const buttonGroupOne = [
  {
    id: 0,
    icon: 'mdi-format-paragraph',
    command: { name: 'setParagraph', params: {} },
    isActive: { name: 'paragraph' },
    title: 'Normal text',
  },
  {
    id: 1,
    icon: 'mdi-format-header-1',
    command: { name: 'toggleHeading', params: { level: 1 } },
    isActive: { name: 'heading', params: { level: 1 } },
    title: 'Rubrik',
  },
  {
    id: 2,
    icon: 'mdi-format-header-2',
    command: { name: 'toggleHeading', params: { level: 2 } },
    isActive: { name: 'heading', params: { level: 2 } },
    title: 'Underrubrik',
  },
  {
    id: 3,
    icon: 'mdi-text-short',
    command: { name: 'toggleHeading', params: { level: 3 } },
    isActive: { name: 'heading', params: { level: 3 } },
    title: 'Ingress',
  },
  {
    id: 16,
    icon: 'mdi-format-list-bulleted',
    command: { name: 'toggleBulletList', params: {} },
    isActive: { name: 'bulletList', params: {} },
    title: 'Lista',
  },
  {
    id: 17,
    icon: 'mdi-format-list-numbered',
    command: { name: 'toggleOrderedList', params: {} },
    isActive: { name: 'orderedList', params: {} },
    title: 'Numrerad lista',
  },
]

export const buttonGroupTwo = [
  {
    id: 5,
    icon: 'mdi-subtitles-outline',
    command: { name: 'toggleHeading', params: { level: 4 } },
    isActive: { name: 'heading', params: { level: 4 } },
    title: 'Bildtext',
  },
  {
    id: 6,
    icon: 'mdi-information-variant',
    command: { name: 'toggleHeading', params: { level: 5 } },
    isActive: { name: 'heading', params: { level: 5 } },
    title: 'Informationsblock',
  },
  // {
  //   id: 7,
  //   icon: 'mdi-format-quote-close',
  //   command: { name: 'toggleBlockquote', params: {} },
  //   isActive: { name: 'blockquote', params: null },
  //   title:''
  // },

  {
    id: 8,
    icon: 'mdi-arrow-split-horizontal',
    command: { name: 'setHorizontalRule', params: {} },
    title: 'Avdelare',
  },
]

export const buttonGroupThree = [
  { id: 10, icon: 'mdi-undo', command: { name: 'undo', params: {} }, title: 'Ångra' },
  { id: 11, icon: 'mdi-redo', command: { name: 'redo', params: {} }, title: 'Gör om' },
]

export const buttonGroupFour = [
  {
    id: 12,
    icon: 'mdi-format-bold',
    command: { name: 'toggleBold', params: {} },
    isActive: { name: 'bold', params: {} },
  },
  {
    id: 13,
    icon: 'mdi-format-italic',
    command: { name: 'toggleItalic', params: {} },
    isActive: { name: 'italic', params: {} },
  },
  {
    id: 14,
    icon: 'mdi-format-underline',
    command: { name: 'toggleUnderline', params: {} },
    isActive: { name: 'underline', params: {} },
  },
  {
    id: 15,
    icon: 'mdi-format-strikethrough',
    command: { name: 'toggleStrike', params: {}, isActive: { name: 'strike', params: {} } },
  },
]
